import { call, put, select } from 'redux-saga/effects'

import VALUES from 'core/data-model/constants/values'
import { calculateTotalAllocation } from 'core/service/investment'
import { getServiceWrapper } from 'core/service-wrapper'
import { resetLstuFundConsents } from 'quick-quote/product-investment/fund-allocation/lstu/actions'
import { getSelectedAllocationOption } from 'quick-quote/product-investment/fund-allocation/lstu/selectors'
import {
  updateRppFundAllocation,
  updateRppTotalFundAllocation,
} from 'quick-quote/product-investment/fund-allocation/rpp/actions'
import { getRppFundAllocations } from 'quick-quote/product-investment/fund-allocation/rpp/selectors'
import { updateFundAllocation } from 'quick-quote/product-investment/fund-allocation/utils'
import { getRiskEvaluated } from 'quick-quote/product-investment/risk-questionnaire/selectors'
import { getSelectedDisplayProductQuery } from 'quick-quote/product-selection/selectors'

export function* onCalculateRppTotalAllocationRequest(action) {
  const fundAllocations = yield select(getRppFundAllocations)
  yield call(processAndUpdateRppFundAllocation, updateFundAllocation(fundAllocations, action.payload))
}

export function* processAndUpdateRppFundAllocation(fundAllocations) {
  const serviceWrapper = getServiceWrapper()
  const displayProductQuery = yield select(getSelectedDisplayProductQuery)
  const insuredRiskLevel = yield select(getRiskEvaluated)
  const allocationResult = yield call(
    calculateTotalAllocation,
    displayProductQuery,
    insuredRiskLevel.value,
    fundAllocations,
    serviceWrapper.products.INVESTMENT.getFundLimit
  )
  yield put(updateRppTotalFundAllocation(allocationResult.totalAllocation))
  yield put(updateRppFundAllocation(allocationResult.fundAllocations))
}

export function* onEditRppFundAllocation() {
  const selectedLstuOption = yield select(getSelectedAllocationOption)
  if (selectedLstuOption === VALUES.LSTU_FUND_ALLOCATION_OPTION.SAME_AS_RPP) {
    yield put(resetLstuFundConsents())
  }
}
